import { render, staticRenderFns } from "./PanelHearing.vue?vue&type=template&id=94d3c33e&"
import script from "./PanelHearing.vue?vue&type=script&lang=ts&"
export * from "./PanelHearing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports